// extracted by mini-css-extract-plugin
export var container = "blogSubscribeBanner-module--container--b65bc";
export var heading = "blogSubscribeBanner-module--heading--b0299";
export var wrapper = "blogSubscribeBanner-module--wrapper--6f8a0";